import * as types from "./types";

const mutations = {
    [types.LOADING_JOURNALENTRY](state, value) {
        state.loading = value;
    },
    [types.GET_JOURNALENTRY_LIST](state, journalentry) {
        state.journalentry = journalentry;
    },
    [types.GET_JOURNALENTRY_ID](state, id) {
        state.id = id;
    },
    [types.REMOVE_JOURNALENTRY](state, id) {        
        state.journalentry = state.journalentry.filter((x) => x.id !== id);        
    },
    [types.ADD_JOURNALENTRY](state, journalentry) {        
        state.journalentry.unshift(journalentry);
    },
    [types.UPDATE_JOURNALENTRY](state, journalentry) {        
        const journalentryIndex = state.journalentry.findIndex((x) => x.id === journalentry.id);
        state.journalentry[journalentryIndex] = journalentry;        
    }
};

export default mutations;